import { cn, ModuleProperties } from '@/lib/core';
import { ComponentSettingsPropertiesModel } from '@/services/platform/api/model';
import { CSSProperties } from 'react';

interface ModuleWrapperClassNames {
  base?: string;
  wrapper?: string;
  container?: string;
  grid?: string;
}

export interface ModuleWrapperProperties {
  component?: ModuleProperties | undefined;
  classNames?: ModuleWrapperClassNames;
  props?: object;
  beforeChildren?: React.ReactNode;
  children: React.ReactNode;
  isFullWidth?: boolean | undefined;
  style?: CSSProperties | undefined;
}

const ModuleWrapper: React.FC<ModuleWrapperProperties> = ({
  component,
  classNames,
  props,
  beforeChildren,
  children,
  isFullWidth = true,
  style,
}) => {
  const settings_properties = component?.settings?.properties as ComponentSettingsPropertiesModel | undefined;
  const module_color = settings_properties?.backgroundColor as string | undefined;

  if (!isFullWidth) {
    isFullWidth = settings_properties?.fullWidth ?? false;
  }

  return (
    !settings_properties?.hide && (
      <section
        data-index={component?.index}
        id={settings_properties?.anchor ?? `${component?.content?.contentType}_${component?.content?.id}`}
        style={
          module_color && typeof module_color === 'string'
            ? { ...style, backgroundColor: module_color }
            : style
        }
        className={cn([
          'flex flex-col justify-center lg:flex-row',
          //'last-of-type:pb-8 lg:last-of-type:pb-10',
          module_color &&
            `my-8 last-of-type:mb-0! last-of-type:pb-0! lg:my-10 last-of-type:lg:mb-0! last-of-type:lg:pb-0!`,
          classNames?.base,
          settings_properties?.class,
        ])}
      >
        {beforeChildren}
        <div
          //id={settings_properties?.anchor ?? ''}
          className={cn([isFullWidth ? 'w-full' : 'container w-full', 'flex', classNames?.container])}
          {...props}
        >
          <div
            className={cn(
              'flex w-full flex-col',
              module_color ? 'py-12 lg:py-20' : 'py-8 lg:py-10',
              classNames?.wrapper,
              {
                'pb-0! lg:pb-0!': settings_properties?.noSpacingBottom,
                'pt-0! lg:pt-0!': settings_properties?.noSpacingTop,
              }
            )}
          >
            <div className={cn('grid grid-cols-2 lg:grid-cols-12', 'gap-6', classNames?.grid)}>
              {children}
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default ModuleWrapper;
